import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useInspection } from 'store/inspection';

import { OnItemExpandedChangeOptions } from 'hooks/useAccordionsExpansion';

export function useInspectionDocumentDeepLinkExpansion(
  onItemExpandedChange: (
    id: string,
    expanded: boolean,
    changeOptions?: OnItemExpandedChangeOptions
  ) => void
): void {
  const { pathname } = useLocation();
  const { inspection } = useInspection();

  useEffect(() => {
    if (!inspection) {
      return;
    }

    const protocolItemMatch = pathname.match(/\/protocolItem\/([^/]+)/);
    if (protocolItemMatch) {
      const protocolItem = inspection.protocol?.find(
        (item) => item._id === protocolItemMatch[1]
      );
      if (protocolItem) {
        onItemExpandedChange(protocolItem.templateChecklistItem._id, true, {
          userInitiated: false,
        });
        return;
      }
    }

    const legacyProtocolMatch = pathname.match(/\/protocol\/([^/]+)/);
    if (legacyProtocolMatch) {
      const protocolItem = inspection.protocol?.find(
        (item) => item._id === legacyProtocolMatch[1]
      );
      if (protocolItem) {
        onItemExpandedChange(protocolItem.templateChecklistItem._id, true, {
          userInitiated: false,
        });
        return;
      }
    }

    const checklistDocumentMatch = pathname.match(/\/checklist\/([^/]+)\//);
    if (checklistDocumentMatch) {
      onItemExpandedChange(checklistDocumentMatch[1], true, {
        userInitiated: false,
      });
      return;
    }

    const protocolSectionMatch = pathname.match(
      /\/inspection\/[^/]+\/section\/([^/]+)/
    );
    if (protocolSectionMatch) {
      const protocolSection = inspection.sections?.find(
        (section) => section._id === protocolSectionMatch[1]
      );
      if (protocolSection?.checklistSectionId) {
        onItemExpandedChange(protocolSection.checklistSectionId, true, {
          userInitiated: false,
        });
        return;
      }
    }

    const templateSectionMatch = pathname.match(
      /\/inspection\/[^/]+\/template\/[^/]+\/section\/([^/]+)/
    );
    if (templateSectionMatch) {
      onItemExpandedChange(templateSectionMatch[1], true, {
        userInitiated: false,
      });
      return;
    }

    const inspectionTemplateSectionMatch = pathname.match(
      /\/inspectionTemplate\/[^/]+\/section\/([^/]+)/
    );
    if (inspectionTemplateSectionMatch) {
      onItemExpandedChange(inspectionTemplateSectionMatch[1], true, {
        userInitiated: false,
      });
    }
  }, [inspection, onItemExpandedChange, pathname]);
}
